import { GenericProps } from "../../types";
import { InvitesList } from "./InvitesList";
import { NewInvite } from "./NewInvite";

interface Props extends GenericProps {
}

export function Invites(props: Props) {

    const { dispatch, state } = props
    const { api, invites: { invites } } = state

    return <div className="invites">

        <div>

            <h2>
                <i className="fa-solid fa-envelope"></i>
                Invitations
            </h2>

            <InvitesList invites={invites} dispatch={dispatch} api={api} />

        </div>

        <NewInvite {...props} />

    </div>

}
